export type MonitorConfigFormState = {
    active: string;
    alert: string;
    intervalVal: string;
    intervalType: string;
    lookbackVal: string;
    lookbackType: string;
};

export const DEFAULT_MONITOR_CONFIG_FORM: MonitorConfigFormState = {
    active: 'NO',
    alert: 'OFF',
    intervalVal: '',
    intervalType: 'DAY',
    lookbackVal: '',
    lookbackType: 'DAY',
};

export const isMonitorConfigFormDirty = (current: MonitorConfigFormState, initial: MonitorConfigFormState): boolean =>
    current.active !== initial.active ||
    current.alert !== initial.alert ||
    current.intervalVal !== initial.intervalVal ||
    current.intervalType !== initial.intervalType ||
    current.lookbackVal !== initial.lookbackVal ||
    current.lookbackType !== initial.lookbackType;
